// extracted by mini-css-extract-plugin
export var modalClose = "CardModal-module--modal-close--mQiWx";
export var modalButton = "CardModal-module--modal-button--7vfBY";